
<div class="black-inputs">
  <el-row>
    <el-row class="dateChooser" :gutter="5">
      <el-col :span="8">
        <el-date-picker class="datePicker" ref="picker" v-model="datesCash" type="daterange" range-separator="au"
          start-placeholder="Date de début" end-placeholder="Date de fin" format="dd/MM/yyyy" />
      </el-col>
      <el-col :span="4">
        <el-select v-model="typeCash" placeholder="Type">
          <el-option label="Caution" value="caution"></el-option>
          <el-option label="Prépaiement" value="prepaiement"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-select v-model="serviceCash" placeholder="Service">
          <el-option v-for="t in getAllServicesIdsAndName" :key="t" :label="t" :value="t">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-input class="inputEuro" placeholder="Prix / couverts" v-model="priceCash"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input class="inputCouv" placeholder="Couverts minimum" v-model="nbCouv"></el-input>
      </el-col>
    </el-row>
  </el-row>
  <el-row v-loading="loading">
    <el-col :span="7" :offset="9">
      <el-button class="dark" type="primary" @click="closeDialog()">Annuler</el-button>
    </el-col>
    <el-col :span="7" :offset="1">
      <el-button type="primary" @click="validModifications()">Valider</el-button>
    </el-col>
  </el-row>
</div>
